// Datos geográficos hardcodeados (extraídos de omnierp2.sql)
// Estos datos son estáticos (geografía DR/USA) y no cambian.

export const PAISES = [
  { id_pais: 1, descripcion: 'República Dominicana' },
  { id_pais: 2, descripcion: 'Estados Unidos' },
];

export const TIPOS_DIRECCION = [
  { id_tipo_direccion: 1, descripcion: 'Casa' },
  { id_tipo_direccion: 2, descripcion: 'Trabajo' },
  { id_tipo_direccion: 3, descripcion: 'Oficina' },
];

export const PROVINCIAS = [
  { id_provincia: 1, descripcion: "Distrito Nacional", id_pais: 1 },
  { id_provincia: 2, descripcion: "Azua", id_pais: 1 },
  { id_provincia: 3, descripcion: "Baoruco", id_pais: 1 },
  { id_provincia: 4, descripcion: "Barahona", id_pais: 1 },
  { id_provincia: 5, descripcion: "Dajabón", id_pais: 1 },
  { id_provincia: 6, descripcion: "Duarte", id_pais: 1 },
  { id_provincia: 7, descripcion: "Elías Piña", id_pais: 1 },
  { id_provincia: 8, descripcion: "El Seibo", id_pais: 1 },
  { id_provincia: 9, descripcion: "Espaillat", id_pais: 1 },
  { id_provincia: 10, descripcion: "Independencia", id_pais: 1 },
  { id_provincia: 11, descripcion: "La Altagracia", id_pais: 1 },
  { id_provincia: 12, descripcion: "La Romana", id_pais: 1 },
  { id_provincia: 13, descripcion: "La Vega", id_pais: 1 },
  { id_provincia: 14, descripcion: "María Trinidad Sánchez", id_pais: 1 },
  { id_provincia: 15, descripcion: "Monte Cristi", id_pais: 1 },
  { id_provincia: 16, descripcion: "Pedernales", id_pais: 1 },
  { id_provincia: 17, descripcion: "Peravia", id_pais: 1 },
  { id_provincia: 18, descripcion: "Puerto Plata", id_pais: 1 },
  { id_provincia: 19, descripcion: "Hermanas Mirabal", id_pais: 1 },
  { id_provincia: 20, descripcion: "Samaná", id_pais: 1 },
  { id_provincia: 21, descripcion: "San Cristóbal", id_pais: 1 },
  { id_provincia: 22, descripcion: "San Juan", id_pais: 1 },
  { id_provincia: 23, descripcion: "San Pedro de Macorís", id_pais: 1 },
  { id_provincia: 24, descripcion: "Sánchez Ramírez", id_pais: 1 },
  { id_provincia: 25, descripcion: "Santiago", id_pais: 1 },
  { id_provincia: 26, descripcion: "Santiago Rodríguez", id_pais: 1 },
  { id_provincia: 27, descripcion: "Valverde", id_pais: 1 },
  { id_provincia: 28, descripcion: "Monseñor Nouel", id_pais: 1 },
  { id_provincia: 29, descripcion: "Monte Plata", id_pais: 1 },
  { id_provincia: 30, descripcion: "Hato Mayor", id_pais: 1 },
  { id_provincia: 31, descripcion: "San José de Ocoa", id_pais: 1 },
  { id_provincia: 32, descripcion: "Santo Domingo", id_pais: 1 },
  { id_provincia: 33, descripcion: "Alabama", id_pais: 2 },
  { id_provincia: 34, descripcion: "Alaska", id_pais: 2 },
  { id_provincia: 35, descripcion: "Arizona", id_pais: 2 },
  { id_provincia: 36, descripcion: "Arkansas", id_pais: 2 },
  { id_provincia: 37, descripcion: "California", id_pais: 2 },
  { id_provincia: 38, descripcion: "Colorado", id_pais: 2 },
  { id_provincia: 39, descripcion: "Connecticut", id_pais: 2 },
  { id_provincia: 40, descripcion: "Delaware", id_pais: 2 },
  { id_provincia: 41, descripcion: "Florida", id_pais: 2 },
  { id_provincia: 42, descripcion: "Georgia", id_pais: 2 },
  { id_provincia: 43, descripcion: "Hawaii", id_pais: 2 },
  { id_provincia: 44, descripcion: "Idaho", id_pais: 2 },
  { id_provincia: 45, descripcion: "Illinois", id_pais: 2 },
  { id_provincia: 46, descripcion: "Indiana", id_pais: 2 },
  { id_provincia: 47, descripcion: "Iowa", id_pais: 2 },
  { id_provincia: 48, descripcion: "Kansas", id_pais: 2 },
  { id_provincia: 49, descripcion: "Kentucky", id_pais: 2 },
  { id_provincia: 50, descripcion: "Louisiana", id_pais: 2 },
  { id_provincia: 51, descripcion: "Maine", id_pais: 2 },
  { id_provincia: 52, descripcion: "Maryland", id_pais: 2 },
  { id_provincia: 53, descripcion: "Massachusetts", id_pais: 2 },
  { id_provincia: 54, descripcion: "Michigan", id_pais: 2 },
  { id_provincia: 55, descripcion: "Minnesota", id_pais: 2 },
  { id_provincia: 56, descripcion: "Mississippi", id_pais: 2 },
  { id_provincia: 57, descripcion: "Missouri", id_pais: 2 },
  { id_provincia: 58, descripcion: "Montana", id_pais: 2 },
  { id_provincia: 59, descripcion: "Nebraska", id_pais: 2 },
  { id_provincia: 60, descripcion: "Nevada", id_pais: 2 },
  { id_provincia: 61, descripcion: "New Hampshire", id_pais: 2 },
  { id_provincia: 62, descripcion: "New Jersey", id_pais: 2 },
  { id_provincia: 63, descripcion: "New Mexico", id_pais: 2 },
  { id_provincia: 64, descripcion: "New York", id_pais: 2 },
  { id_provincia: 65, descripcion: "North Carolina", id_pais: 2 },
  { id_provincia: 66, descripcion: "North Dakota", id_pais: 2 },
  { id_provincia: 67, descripcion: "Ohio", id_pais: 2 },
  { id_provincia: 68, descripcion: "Oklahoma", id_pais: 2 },
  { id_provincia: 69, descripcion: "Oregon", id_pais: 2 },
  { id_provincia: 70, descripcion: "Pennsylvania", id_pais: 2 },
  { id_provincia: 71, descripcion: "Rhode Island", id_pais: 2 },
  { id_provincia: 72, descripcion: "South Carolina", id_pais: 2 },
  { id_provincia: 73, descripcion: "South Dakota", id_pais: 2 },
  { id_provincia: 74, descripcion: "Tennessee", id_pais: 2 },
  { id_provincia: 75, descripcion: "Texas", id_pais: 2 },
  { id_provincia: 76, descripcion: "Utah", id_pais: 2 },
  { id_provincia: 77, descripcion: "Vermont", id_pais: 2 },
  { id_provincia: 78, descripcion: "Virginia", id_pais: 2 },
  { id_provincia: 79, descripcion: "Washington", id_pais: 2 },
  { id_provincia: 80, descripcion: "West Virginia", id_pais: 2 },
  { id_provincia: 81, descripcion: "Wisconsin", id_pais: 2 },
  { id_provincia: 82, descripcion: "Wyoming", id_pais: 2 },
];

export const MUNICIPIOS = [
  { id_municipio: 1, descripcion: "MUNICIPIO SANTO DOMINGO DE GUZMÁN", id_provincia: 1 },
  { id_municipio: 2, descripcion: "SANTO DOMINGO DE GUZMÁN (D. M.).", id_provincia: 1 },
  { id_municipio: 3, descripcion: "MUNICIPIO AZUA", id_provincia: 2 },
  { id_municipio: 4, descripcion: "AZUA (D. M.)", id_provincia: 2 },
  { id_municipio: 5, descripcion: "BARRO ARRIBA (D. M.)", id_provincia: 2 },
  { id_municipio: 6, descripcion: "LAS BARÍAS-LA ESTANCIA (D. M.)", id_provincia: 2 },
  { id_municipio: 7, descripcion: "LOS JOVILLOS (D. M.)", id_provincia: 2 },
  { id_municipio: 8, descripcion: "PUERTO VIEJO (D. M.)", id_provincia: 2 },
  { id_municipio: 9, descripcion: "BARRERAS (D. M.)", id_provincia: 2 },
  { id_municipio: 10, descripcion: "DOÑA EMMA BALAGUER VIUDA VALLEJO (D. M.)", id_provincia: 2 },
  { id_municipio: 11, descripcion: "CLAVELLINA (D. M.)", id_provincia: 2 },
  { id_municipio: 12, descripcion: "LAS LOMAS (D. M.)", id_provincia: 2 },
  { id_municipio: 13, descripcion: "MUNICIPIO LAS CHARCAS", id_provincia: 2 },
  { id_municipio: 14, descripcion: "LAS CHARCAS (D. M.)", id_provincia: 2 },
  { id_municipio: 15, descripcion: "PALMAR DE OCOA (D. M.)", id_provincia: 2 },
  { id_municipio: 16, descripcion: "MUNICIPIO LAS YAYAS DE VIAJAMA", id_provincia: 2 },
  { id_municipio: 17, descripcion: "LAS YAYAS DE VIAJAMA (D. M.)", id_provincia: 2 },
  { id_municipio: 18, descripcion: "VILLARPANDO (D. M.)", id_provincia: 2 },
  { id_municipio: 19, descripcion: "HATO NUEVO CORTÉS (D. M.)", id_provincia: 2 },
  { id_municipio: 20, descripcion: "MUNICIPIO PADRE LAS CASAS", id_provincia: 2 },
  { id_municipio: 21, descripcion: "PADRE LAS CASAS (D. M.)", id_provincia: 2 },
  { id_municipio: 22, descripcion: "LAS LAGUNAS (D. M.)", id_provincia: 2 },
  { id_municipio: 23, descripcion: "LA SIEMBRA (D. M.)", id_provincia: 2 },
  { id_municipio: 24, descripcion: "MONTE BONITO (D. M.)", id_provincia: 2 },
  { id_municipio: 25, descripcion: "LOS FRÍOS (D. M.)", id_provincia: 2 },
  { id_municipio: 26, descripcion: "MUNICIPIO PERALTA", id_provincia: 2 },
  { id_municipio: 27, descripcion: "PERALTA (D. M.)", id_provincia: 2 },
  { id_municipio: 28, descripcion: "MUNICIPIO SABANA YEGUA", id_provincia: 2 },
  { id_municipio: 29, descripcion: "SABANA YEGUA (D. M.)", id_provincia: 2 },
  { id_municipio: 30, descripcion: "PROYECTO 4 (D. M.)", id_provincia: 2 },
  { id_municipio: 31, descripcion: "GANADERO (D. M.)", id_provincia: 2 },
  { id_municipio: 32, descripcion: "PROYECTO 2-C (D. M.)", id_provincia: 2 },
  { id_municipio: 33, descripcion: "MUNICIPIO PUEBLO VIEJO", id_provincia: 2 },
  { id_municipio: 34, descripcion: "PUEBLO VIEJO (D. M.)", id_provincia: 2 },
  { id_municipio: 35, descripcion: "EL ROSARIO (D. M.)", id_provincia: 2 },
  { id_municipio: 36, descripcion: "MUNICIPIO TÁBARA ARRIBA", id_provincia: 2 },
  { id_municipio: 37, descripcion: "TÁBARA ARRIBA (D. M.)", id_provincia: 2 },
  { id_municipio: 38, descripcion: "TÁBARA ABAJO (D. M.)", id_provincia: 2 },
  { id_municipio: 39, descripcion: "AMIAMA GÓMEZ (D. M.)", id_provincia: 2 },
  { id_municipio: 40, descripcion: "LOS TOROS (D. M.)", id_provincia: 2 },
  { id_municipio: 41, descripcion: "MUNICIPIO GUAYABAL", id_provincia: 2 },
  { id_municipio: 42, descripcion: "GUAYABAL (D. M.)", id_provincia: 2 },
  { id_municipio: 43, descripcion: "MUNICIPIO ESTEBANÍA", id_provincia: 2 },
  { id_municipio: 44, descripcion: "ESTEBANÍA (D. M.)", id_provincia: 2 },
  { id_municipio: 45, descripcion: "MUNICIPIO NEIBA", id_provincia: 3 },
  { id_municipio: 46, descripcion: "NEIBA (D. M.)", id_provincia: 3 },
  { id_municipio: 47, descripcion: "EL PALMAR (D. M.)", id_provincia: 3 },
  { id_municipio: 48, descripcion: "MUNICIPIO GALVÁN", id_provincia: 3 },
  { id_municipio: 49, descripcion: "GALVÁN (D. M.)", id_provincia: 3 },
  { id_municipio: 50, descripcion: "EL SALADO (D. M.)", id_provincia: 3 },
  { id_municipio: 51, descripcion: "MUNICIPIO TAMAYO", id_provincia: 3 },
  { id_municipio: 52, descripcion: "TAMAYO (D. M.)", id_provincia: 3 },
  { id_municipio: 53, descripcion: "UVILLA (D. M.)", id_provincia: 3 },
  { id_municipio: 54, descripcion: "SANTANA (D. M.)", id_provincia: 3 },
  { id_municipio: 55, descripcion: "MONSERRATE (MONTSERRAT) (D. M.)", id_provincia: 3 },
  { id_municipio: 56, descripcion: "CABEZA DE TORO (D. M.)", id_provincia: 3 },
  { id_municipio: 57, descripcion: "MENA (D. M.)", id_provincia: 3 },
  { id_municipio: 58, descripcion: "SANTA BÁRBARA EL 6 (D. M.)", id_provincia: 3 },
  { id_municipio: 59, descripcion: "MUNICIPIO VILLA JARAGUA", id_provincia: 3 },
  { id_municipio: 60, descripcion: "VILLA JARAGUA (D. M.)", id_provincia: 3 },
  { id_municipio: 61, descripcion: "MUNICIPIO LOS RÍOS", id_provincia: 3 },
  { id_municipio: 62, descripcion: "LOS RÍOS (D. M.)", id_provincia: 3 },
  { id_municipio: 63, descripcion: "LAS CLAVELLINAS (D. M.)", id_provincia: 3 },
  { id_municipio: 64, descripcion: "MUNICIPIO BARAHONA", id_provincia: 4 },
  { id_municipio: 65, descripcion: "BARAHONA (D. M.)", id_provincia: 4 },
  { id_municipio: 66, descripcion: "EL CACHÓN (D. M.)", id_provincia: 4 },
  { id_municipio: 67, descripcion: "LA GUÁZARA (D. M.)", id_provincia: 4 },
  { id_municipio: 68, descripcion: "VILLA CENTRAL (D. M.)", id_provincia: 4 },
  { id_municipio: 69, descripcion: "MUNICIPIO CABRAL", id_provincia: 4 },
  { id_municipio: 70, descripcion: "CABRAL (D. M.)", id_provincia: 4 },
  { id_municipio: 71, descripcion: "MUNICIPIO ENRIQUILLO", id_provincia: 4 },
  { id_municipio: 72, descripcion: "ENRIQUILLO (D. M.)", id_provincia: 4 },
  { id_municipio: 73, descripcion: "ARROYO DULCE (D. M.)", id_provincia: 4 },
  { id_municipio: 74, descripcion: "MUNICIPIO PARAÍSO", id_provincia: 4 },
  { id_municipio: 75, descripcion: "PARAÍSO (D. M.)", id_provincia: 4 },
  { id_municipio: 76, descripcion: "LOS PATOS (D. M.)", id_provincia: 4 },
  { id_municipio: 77, descripcion: "MUNICIPIO VICENTE NOBLE", id_provincia: 4 },
  { id_municipio: 78, descripcion: "VICENTE NOBLE (D. M.)", id_provincia: 4 },
  { id_municipio: 79, descripcion: "CANOA (D. M.)", id_provincia: 4 },
  { id_municipio: 80, descripcion: "QUITA CORAZA (D. M.)", id_provincia: 4 },
  { id_municipio: 81, descripcion: "FONDO NEGRO (D. M.)", id_provincia: 4 },
  { id_municipio: 82, descripcion: "MUNICIPIO EL PEÑÓN", id_provincia: 4 },
  { id_municipio: 83, descripcion: "EL PEÑÓN (D. M.)", id_provincia: 4 },
  { id_municipio: 84, descripcion: "MUNICIPIO LA CIÉNAGA", id_provincia: 4 },
  { id_municipio: 85, descripcion: "LA CIÉNAGA (D. M.)", id_provincia: 4 },
  { id_municipio: 86, descripcion: "BAHORUCO (D. M.)", id_provincia: 4 },
  { id_municipio: 87, descripcion: "MUNICIPIO FUNDACIÓN", id_provincia: 4 },
  { id_municipio: 88, descripcion: "FUNDACIÓN (D. M.)", id_provincia: 4 },
  { id_municipio: 89, descripcion: "PESCADERÍA (D. M.)", id_provincia: 4 },
  { id_municipio: 90, descripcion: "MUNICIPIO LAS SALINAS", id_provincia: 4 },
  { id_municipio: 91, descripcion: "LAS SALINAS (D. M.)", id_provincia: 4 },
  { id_municipio: 92, descripcion: "MUNICIPIO POLO", id_provincia: 4 },
  { id_municipio: 93, descripcion: "POLO (D. M.)", id_provincia: 4 },
  { id_municipio: 94, descripcion: "MUNICIPIO JAQUIMEYES", id_provincia: 4 },
  { id_municipio: 95, descripcion: "JAQUIMEYES (D. M.)", id_provincia: 4 },
  { id_municipio: 96, descripcion: "PALO ALTO (D. M.)", id_provincia: 4 },
  { id_municipio: 97, descripcion: "MUNICIPIO DAJABÓN", id_provincia: 5 },
  { id_municipio: 98, descripcion: "DAJABÓN (D. M.)", id_provincia: 5 },
  { id_municipio: 99, descripcion: "CAÑONGO (D. M.)", id_provincia: 5 },
  { id_municipio: 100, descripcion: "MUNICIPIO LOMA DE CABRERA", id_provincia: 5 },
  { id_municipio: 101, descripcion: "LOMA DE CABRERA (D. M.)", id_provincia: 5 },
  { id_municipio: 102, descripcion: "CAPOTILLO (D. M.)", id_provincia: 5 },
  { id_municipio: 103, descripcion: "SANTIAGO DE LA CRUZ (D. M.)", id_provincia: 5 },
  { id_municipio: 104, descripcion: "MUNICIPIO PARTIDO", id_provincia: 5 },
  { id_municipio: 105, descripcion: "PARTIDO (D. M.)", id_provincia: 5 },
  { id_municipio: 106, descripcion: "MUNICIPIO RESTAURACIÓN", id_provincia: 5 },
  { id_municipio: 107, descripcion: "RESTAURACIÓN (D. M.)", id_provincia: 5 },
  { id_municipio: 108, descripcion: "MUNICIPIO EL PINO", id_provincia: 5 },
  { id_municipio: 109, descripcion: "EL PINO (D. M.)", id_provincia: 5 },
  { id_municipio: 110, descripcion: "MANUEL BUENO (D. M.)", id_provincia: 5 },
  { id_municipio: 111, descripcion: "MUNICIPIO SAN FRANCISCO DE MACORÍS", id_provincia: 6 },
  { id_municipio: 112, descripcion: "SAN FRANCISCO DE MACORÍS (D. M.)", id_provincia: 6 },
  { id_municipio: 113, descripcion: "LA PEÑA (D. M.)", id_provincia: 6 },
  { id_municipio: 114, descripcion: "CENOVÍ (D. M.)", id_provincia: 6 },
  { id_municipio: 115, descripcion: "JAYA (D. M.)", id_provincia: 6 },
  { id_municipio: 116, descripcion: "PRESIDENTE DON ANTONIO GUZMÁN FERNÁNDEZ (D. M.)", id_provincia: 6 },
  { id_municipio: 117, descripcion: "MUNICIPIO ARENOSO", id_provincia: 6 },
  { id_municipio: 118, descripcion: "ARENOSO (D. M.)", id_provincia: 6 },
  { id_municipio: 119, descripcion: "LAS COLES (D. M.)", id_provincia: 6 },
  { id_municipio: 120, descripcion: "EL AGUACATE (D. M.)", id_provincia: 6 },
  { id_municipio: 121, descripcion: "MUNICIPIO CASTILLO", id_provincia: 6 },
  { id_municipio: 122, descripcion: "CASTILLO (D. M.)", id_provincia: 6 },
  { id_municipio: 123, descripcion: "MUNICIPIO PIMENTEL", id_provincia: 6 },
  { id_municipio: 124, descripcion: "PIMENTEL (D. M.)", id_provincia: 6 },
  { id_municipio: 125, descripcion: "MUNICIPIO VILLA RIVA", id_provincia: 6 },
  { id_municipio: 126, descripcion: "VILLA RIVA (D. M.)", id_provincia: 6 },
  { id_municipio: 127, descripcion: "AGUA SANTA DEL YUNA (D. M.)", id_provincia: 6 },
  { id_municipio: 128, descripcion: "CRISTO REY DE GUARAGUAO (D. M.)", id_provincia: 6 },
  { id_municipio: 129, descripcion: "LAS TARANAS (D. M.)", id_provincia: 6 },
  { id_municipio: 130, descripcion: "BARRAQUITO (D. M.)", id_provincia: 6 },
  { id_municipio: 131, descripcion: "MUNICIPIO LAS GUÁRANAS", id_provincia: 6 },
  { id_municipio: 132, descripcion: "LAS GUÁRANAS (D. M.)", id_provincia: 6 },
  { id_municipio: 133, descripcion: "MUNICIPIO EUGENIO MARÍA DE HOSTOS", id_provincia: 6 },
  { id_municipio: 134, descripcion: "EUGENIO MARÍA DE HOSTOS (D. M.)", id_provincia: 6 },
  { id_municipio: 135, descripcion: "SABANA GRANDE (D. M.)", id_provincia: 6 },
  { id_municipio: 136, descripcion: "MUNICIPIO COMENDADOR", id_provincia: 7 },
  { id_municipio: 137, descripcion: "COMENDADOR (D. M.)", id_provincia: 7 },
  { id_municipio: 138, descripcion: "SABANA LARGA (D. M.)", id_provincia: 7 },
  { id_municipio: 139, descripcion: "GUAYABO (D. M.)", id_provincia: 7 },
  { id_municipio: 140, descripcion: "MUNICIPIO BÁNICA", id_provincia: 7 },
  { id_municipio: 141, descripcion: "BÁNICA (D. M.)", id_provincia: 7 },
  { id_municipio: 142, descripcion: "SABANA CRUZ (D. M.)", id_provincia: 7 },
  { id_municipio: 143, descripcion: "SABANA HIGÜERO (D. M.)", id_provincia: 7 },
  { id_municipio: 144, descripcion: "MUNICIPIO EL LLANO", id_provincia: 7 },
  { id_municipio: 145, descripcion: "EL LLANO (D. M.)", id_provincia: 7 },
  { id_municipio: 146, descripcion: "GUANITO (D. M.)", id_provincia: 7 },
  { id_municipio: 147, descripcion: "MUNICIPIO HONDO VALLE", id_provincia: 7 },
  { id_municipio: 148, descripcion: "HONDO VALLE (D. M.)", id_provincia: 7 },
  { id_municipio: 149, descripcion: "RANCHO DE LA GUARDIA (D. M.)", id_provincia: 7 },
  { id_municipio: 150, descripcion: "MUNICIPIO PEDRO SANTANA", id_provincia: 7 },
  { id_municipio: 151, descripcion: "PEDRO SANTANA (D. M.)", id_provincia: 7 },
  { id_municipio: 152, descripcion: "RÍO LIMPIO (D. M.)", id_provincia: 7 },
  { id_municipio: 153, descripcion: "MUNICIPIO JUAN SANTIAGO", id_provincia: 7 },
  { id_municipio: 154, descripcion: "JUAN SANTIAGO (D. M.)", id_provincia: 7 },
  { id_municipio: 155, descripcion: "MUNICIPIO EL SEIBO", id_provincia: 8 },
  { id_municipio: 156, descripcion: "EL SEIBO (D. M.)", id_provincia: 8 },
  { id_municipio: 157, descripcion: "PEDRO SÁNCHEZ (D. M.)", id_provincia: 8 },
  { id_municipio: 158, descripcion: "SAN FRANCISCO-VICENTILLO (D. M.)", id_provincia: 8 },
  { id_municipio: 159, descripcion: "SANTA LUCÍA (D. M.)", id_provincia: 8 },
  { id_municipio: 160, descripcion: "MUNICIPIO MICHES", id_provincia: 8 },
  { id_municipio: 161, descripcion: "MICHES (D. M.)", id_provincia: 8 },
  { id_municipio: 162, descripcion: "EL CEDRO (D. M.)", id_provincia: 8 },
  { id_municipio: 163, descripcion: "LA GINA (D. M.)", id_provincia: 8 },
  { id_municipio: 164, descripcion: "MUNICIPIO MOCA", id_provincia: 9 },
  { id_municipio: 165, descripcion: "MOCA (D. M.)", id_provincia: 9 },
  { id_municipio: 166, descripcion: "JOSÉ CONTRERAS (D. M.)", id_provincia: 9 },
  { id_municipio: 167, descripcion: "SAN VÍCTOR (D. M.)", id_provincia: 9 },
  { id_municipio: 168, descripcion: "JUAN LÓPEZ (D. M.)", id_provincia: 9 },
  { id_municipio: 169, descripcion: "LAS LAGUNAS (D. M.)", id_provincia: 9 },
  { id_municipio: 170, descripcion: "CANCA LA REYNA (D. M.)", id_provincia: 9 },
  { id_municipio: 171, descripcion: "EL HIGÜERITO (D. M.)", id_provincia: 9 },
  { id_municipio: 172, descripcion: "MONTE DE LA JAGUA (D. M.)", id_provincia: 9 },
  { id_municipio: 173, descripcion: "LA ORTEGA (D. M.)", id_provincia: 9 },
  { id_municipio: 174, descripcion: "MUNICIPIO CAYETANO GERMOSÉN", id_provincia: 9 },
  { id_municipio: 175, descripcion: "CAYETANO GERMOSÉN (D. M.)", id_provincia: 9 },
  { id_municipio: 176, descripcion: "MUNICIPIO GASPAR HERNÁNDEZ", id_provincia: 9 },
  { id_municipio: 177, descripcion: "GASPAR HERNÁNDEZ (D. M.)", id_provincia: 9 },
  { id_municipio: 178, descripcion: "JOBA ARRIBA (D. M.)", id_provincia: 9 },
  { id_municipio: 179, descripcion: "VERAGUA (D. M.)", id_provincia: 9 },
  { id_municipio: 180, descripcion: "VILLA MAGANTE (D. M.)", id_provincia: 9 },
  { id_municipio: 181, descripcion: "MUNICIPIO JAMAO AL NORTE", id_provincia: 9 },
  { id_municipio: 182, descripcion: "JAMAO AL NORTE (D. M.)", id_provincia: 9 },
  { id_municipio: 183, descripcion: "MUNICIPIO JIMANÍ", id_provincia: 10 },
  { id_municipio: 184, descripcion: "JIMANÍ (D. M.)", id_provincia: 10 },
  { id_municipio: 185, descripcion: "EL LIMÓN (D. M.)", id_provincia: 10 },
  { id_municipio: 186, descripcion: "BOCA DE CACHÓN (D. M.)", id_provincia: 10 },
  { id_municipio: 187, descripcion: "MUNICIPIO DUVERGÉ", id_provincia: 10 },
  { id_municipio: 188, descripcion: "DUVERGÉ (D. M.)", id_provincia: 10 },
  { id_municipio: 189, descripcion: "VENGAN A VER (D. M.)", id_provincia: 10 },
  { id_municipio: 190, descripcion: "MUNICIPIO LA DESCUBIERTA", id_provincia: 10 },
  { id_municipio: 191, descripcion: "LA DESCUBIERTA (D. M.)", id_provincia: 10 },
  { id_municipio: 192, descripcion: "MUNICIPIO POSTRER RÍO", id_provincia: 10 },
  { id_municipio: 193, descripcion: "POSTRER RÍO (D. M.)", id_provincia: 10 },
  { id_municipio: 194, descripcion: "GUAYABAL (D. M.)", id_provincia: 10 },
  { id_municipio: 195, descripcion: "MUNICIPIO CRISTÓBAL", id_provincia: 10 },
  { id_municipio: 196, descripcion: "CRISTÓBAL (D. M.)", id_provincia: 10 },
  { id_municipio: 197, descripcion: "BATEY 8 (D. M.)", id_provincia: 10 },
  { id_municipio: 198, descripcion: "MUNICIPIO MELLA", id_provincia: 10 },
  { id_municipio: 199, descripcion: "MELLA (D. M.)", id_provincia: 10 },
  { id_municipio: 200, descripcion: "LA COLONIA (D. M.)", id_provincia: 10 },
  { id_municipio: 201, descripcion: "MUNICIPIO HIGÜEY", id_provincia: 11 },
  { id_municipio: 202, descripcion: "HIGÜEY (D. M.)", id_provincia: 11 },
  { id_municipio: 203, descripcion: "LAS LAGUNAS DE NISIBÓN (D. M.)", id_provincia: 11 },
  { id_municipio: 204, descripcion: "LA OTRA BANDA (D. M.)", id_provincia: 11 },
  { id_municipio: 205, descripcion: "VERÓN PUNTA CANA (D. M.) (Incluye Bávaro)", id_provincia: 11 },
  { id_municipio: 206, descripcion: "MUNICIPIO SAN RAFAEL DEL YUMA", id_provincia: 11 },
  { id_municipio: 207, descripcion: "SAN RAFAEL DEL YUMA (D. M.)", id_provincia: 11 },
  { id_municipio: 208, descripcion: "BOCA DE YUMA (D. M.)", id_provincia: 11 },
  { id_municipio: 209, descripcion: "BAYAHÍBE (D. M.)", id_provincia: 11 },
  { id_municipio: 210, descripcion: "MUNICIPIO LA ROMANA", id_provincia: 12 },
  { id_municipio: 211, descripcion: "LA ROMANA (D. M.)", id_provincia: 12 },
  { id_municipio: 212, descripcion: "CALETA (D. M.)", id_provincia: 12 },
  { id_municipio: 213, descripcion: "MUNICIPIO GUAYMATE", id_provincia: 12 },
  { id_municipio: 214, descripcion: "GUAYMATE (D. M.)", id_provincia: 12 },
  { id_municipio: 215, descripcion: "MUNICIPIO VILLA HERMOSA", id_provincia: 12 },
  { id_municipio: 216, descripcion: "VILLA HERMOSA (D. M.)", id_provincia: 12 },
  { id_municipio: 217, descripcion: "CUMAYASA (D. M.)", id_provincia: 12 },
  { id_municipio: 218, descripcion: "MUNICIPIO LA VEGA", id_provincia: 13 },
  { id_municipio: 219, descripcion: "LA VEGA (D. M.)", id_provincia: 13 },
  { id_municipio: 220, descripcion: "RÍO VERDE ARRIBA (D. M.)", id_provincia: 13 },
  { id_municipio: 221, descripcion: "EL RANCHITO (D. M.)", id_provincia: 13 },
  { id_municipio: 222, descripcion: "TAVERAS (D. M.)", id_provincia: 13 },
  { id_municipio: 223, descripcion: "DON JUAN RODRÍGUEZ (D.M.)", id_provincia: 13 },
  { id_municipio: 224, descripcion: "MUNICIPIO CONSTANZA", id_provincia: 13 },
  { id_municipio: 225, descripcion: "CONSTANZA (D. M.)", id_provincia: 13 },
  { id_municipio: 226, descripcion: "TIREO (D. M.)", id_provincia: 13 },
  { id_municipio: 227, descripcion: "LA SABINA (D. M.)", id_provincia: 13 },
  { id_municipio: 228, descripcion: "MUNICIPIO JARABACOA", id_provincia: 13 },
  { id_municipio: 229, descripcion: "JARABACOA (D. M.)", id_provincia: 13 },
  { id_municipio: 230, descripcion: "BUENA VISTA (D. M.)", id_provincia: 13 },
  { id_municipio: 231, descripcion: "MANABAO (D. M.)", id_provincia: 13 },
  { id_municipio: 232, descripcion: "MUNICIPIO JIMA ABAJO", id_provincia: 13 },
  { id_municipio: 233, descripcion: "JIMA ABAJO (D. M.)", id_provincia: 13 },
  { id_municipio: 234, descripcion: "RINCÓN (D. M.)", id_provincia: 13 },
  { id_municipio: 235, descripcion: "MUNICIPIO NAGUA", id_provincia: 14 },
  { id_municipio: 236, descripcion: "NAGUA (D. M.)", id_provincia: 14 },
  { id_municipio: 237, descripcion: "SAN JOSÉ DE MATANZAS (D. M.)", id_provincia: 14 },
  { id_municipio: 238, descripcion: "LAS GORDAS (D. M.)", id_provincia: 14 },
  { id_municipio: 239, descripcion: "ARROYO AL MEDIO (D. M.)", id_provincia: 14 },
  { id_municipio: 240, descripcion: "MUNICIPIO CABRERA", id_provincia: 14 },
  { id_municipio: 241, descripcion: "CABRERA (D. M.)", id_provincia: 14 },
  { id_municipio: 242, descripcion: "ARROYO SALADO (D. M.)", id_provincia: 14 },
  { id_municipio: 243, descripcion: "LA ENTRADA (D. M.)", id_provincia: 14 },
  { id_municipio: 244, descripcion: "MUNICIPIO EL FACTOR", id_provincia: 14 },
  { id_municipio: 245, descripcion: "EL FACTOR (D. M.)", id_provincia: 14 },
  { id_municipio: 246, descripcion: "EL POZO (D. M.)", id_provincia: 14 },
  { id_municipio: 247, descripcion: "MUNICIPIO RÍO SAN JUAN", id_provincia: 14 },
  { id_municipio: 248, descripcion: "RÍO SAN JUAN (D. M.)", id_provincia: 14 },
  { id_municipio: 249, descripcion: "MUNICIPIO MONTE CRISTI", id_provincia: 15 },
  { id_municipio: 250, descripcion: "MONTE CRISTI (D. M.)", id_provincia: 15 },
  { id_municipio: 251, descripcion: "MUNICIPIO CASTAÑUELAS", id_provincia: 15 },
  { id_municipio: 252, descripcion: "CASTAÑUELAS (D. M.)", id_provincia: 15 },
  { id_municipio: 253, descripcion: "PALO VERDE (D. M.)", id_provincia: 15 },
  { id_municipio: 254, descripcion: "MUNICIPIO GUAYUBÍN", id_provincia: 15 },
  { id_municipio: 255, descripcion: "GUAYUBÍN (D. M.)", id_provincia: 15 },
  { id_municipio: 256, descripcion: "VILLA ELISA (D. M.)", id_provincia: 15 },
  { id_municipio: 257, descripcion: "HATILLO PALMA (D. M.)", id_provincia: 15 },
  { id_municipio: 258, descripcion: "CANA CHAPETÓN (D. M.)", id_provincia: 15 },
  { id_municipio: 259, descripcion: "MUNICIPIO LAS MATAS DE SANTA CRUZ", id_provincia: 15 },
  { id_municipio: 260, descripcion: "LAS MATAS DE SANTA CRUZ (D. M.)", id_provincia: 15 },
  { id_municipio: 261, descripcion: "MUNICIPIO PEPILLO SALCEDO", id_provincia: 15 },
  { id_municipio: 262, descripcion: "PEPILLO SALCEDO (MANZANILLO)", id_provincia: 15 },
  { id_municipio: 263, descripcion: "SANTA MARÍA (D. M.)", id_provincia: 15 },
  { id_municipio: 264, descripcion: "MUNICIPIO VILLA VÁSQUEZ", id_provincia: 15 },
  { id_municipio: 265, descripcion: "VILLA VÁSQUEZ", id_provincia: 15 },
  { id_municipio: 266, descripcion: "MUNICIPIO PEDERNALES", id_provincia: 16 },
  { id_municipio: 267, descripcion: "PEDERNALES", id_provincia: 16 },
  { id_municipio: 268, descripcion: "JOSÉ FRANCISCO PEÑA GÓMEZ (D. M.)", id_provincia: 16 },
  { id_municipio: 269, descripcion: "MUNICIPIO OVIEDO", id_provincia: 16 },
  { id_municipio: 270, descripcion: "OVIEDO", id_provincia: 16 },
  { id_municipio: 271, descripcion: "JUANCHO (D. M.)", id_provincia: 16 },
  { id_municipio: 272, descripcion: "MUNICIPIO BANÍ", id_provincia: 17 },
  { id_municipio: 273, descripcion: "BANÍ (D. M.)", id_provincia: 17 },
  { id_municipio: 274, descripcion: "MATANZAS (D. M.)", id_provincia: 17 },
  { id_municipio: 275, descripcion: "VILLA FUNDACIÓN (D. M.)", id_provincia: 17 },
  { id_municipio: 276, descripcion: "SABANA BUEY (D. M.)", id_provincia: 17 },
  { id_municipio: 277, descripcion: "PAYA (D. M.)", id_provincia: 17 },
  { id_municipio: 278, descripcion: "VILLA SOMBRERO (D. M.)", id_provincia: 17 },
  { id_municipio: 279, descripcion: "EL CARRETÓN (D. M.)", id_provincia: 17 },
  { id_municipio: 280, descripcion: "CATALINA (D. M.)", id_provincia: 17 },
  { id_municipio: 281, descripcion: "EL LIMONAL (D. M.)", id_provincia: 17 },
  { id_municipio: 282, descripcion: "LAS BARÍAS (D. M.)", id_provincia: 17 },
  { id_municipio: 283, descripcion: "MUNICIPIO NIZAO", id_provincia: 17 },
  { id_municipio: 284, descripcion: "NIZAO", id_provincia: 17 },
  { id_municipio: 285, descripcion: "PIZARRETE (D. M.)", id_provincia: 17 },
  { id_municipio: 286, descripcion: "SANTANA (D. M.)", id_provincia: 17 },
  { id_municipio: 287, descripcion: "MATANZAS", id_provincia: 17 },
  { id_municipio: 288, descripcion: "MATANZAS", id_provincia: 17 },
  { id_municipio: 289, descripcion: "MUNICIPIO PUERTO PLATA", id_provincia: 18 },
  { id_municipio: 290, descripcion: "PUERTO PLATA (D. M.)", id_provincia: 18 },
  { id_municipio: 291, descripcion: "YÁSICA ARRIBA (D. M.)", id_provincia: 18 },
  { id_municipio: 292, descripcion: "MAIMÓN (D. M.)", id_provincia: 18 },
  { id_municipio: 293, descripcion: "MUNICIPIO ALTAMIRA", id_provincia: 18 },
  { id_municipio: 294, descripcion: "ALTAMIRA", id_provincia: 18 },
  { id_municipio: 295, descripcion: "RÍO GRANDE (D. M.)", id_provincia: 18 },
  { id_municipio: 296, descripcion: "MUNICIPIO GUANANICO", id_provincia: 18 },
  { id_municipio: 297, descripcion: "GUANANICO", id_provincia: 18 },
  { id_municipio: 298, descripcion: "MUNICIPIO IMBERT", id_provincia: 18 },
  { id_municipio: 299, descripcion: "IMBERT", id_provincia: 18 },
  { id_municipio: 300, descripcion: "MUNICIPIO LOS HIDALGOS", id_provincia: 18 },
  { id_municipio: 301, descripcion: "LOS HIDALGOS", id_provincia: 18 },
  { id_municipio: 302, descripcion: "NAVAS (D. M.)", id_provincia: 18 },
  { id_municipio: 303, descripcion: "MUNICIPIO LUPERÓN", id_provincia: 18 },
  { id_municipio: 304, descripcion: "LUPERÓN", id_provincia: 18 },
  { id_municipio: 305, descripcion: "LA ISABELA (D. M.)", id_provincia: 18 },
  { id_municipio: 306, descripcion: "BELLOSO (D. M.)", id_provincia: 18 },
  { id_municipio: 307, descripcion: "EL ESTRECHO DE LUPERÓN OMAR BROSS (D. M.)", id_provincia: 18 },
  { id_municipio: 308, descripcion: "MUNICIPIO SOSÚA", id_provincia: 18 },
  { id_municipio: 309, descripcion: "SOSÚA", id_provincia: 18 },
  { id_municipio: 310, descripcion: "CABARETE (D. M.)", id_provincia: 18 },
  { id_municipio: 311, descripcion: "SABANETA DE YÁSICA (D. M.)", id_provincia: 18 },
  { id_municipio: 312, descripcion: "MUNICIPIO VILLA ISABELA", id_provincia: 18 },
  { id_municipio: 313, descripcion: "VILLA ISABELA", id_provincia: 18 },
  { id_municipio: 314, descripcion: "ESTERO HONDO (D. M.)", id_provincia: 18 },
  { id_municipio: 315, descripcion: "LA JAIBA (D. M.)", id_provincia: 18 },
  { id_municipio: 316, descripcion: "GUALETE (D. M.)", id_provincia: 18 },
  { id_municipio: 317, descripcion: "MUNICIPIO VILLA MONTELLANO", id_provincia: 18 },
  { id_municipio: 318, descripcion: "VILLA MONTELLANO", id_provincia: 18 },
  { id_municipio: 319, descripcion: "MUNICIPIO SALCEDO", id_provincia: 19 },
  { id_municipio: 320, descripcion: "SALCEDO", id_provincia: 19 },
  { id_municipio: 321, descripcion: "JAMAO AFUERA (D. M.)", id_provincia: 19 },
  { id_municipio: 322, descripcion: "MUNICIPIO TENARES", id_provincia: 19 },
  { id_municipio: 323, descripcion: "TENARES", id_provincia: 19 },
  { id_municipio: 324, descripcion: "BLANCO (D. M.)", id_provincia: 19 },
  { id_municipio: 325, descripcion: "MUNICIPIO VILLA TAPIA", id_provincia: 19 },
  { id_municipio: 326, descripcion: "VILLA TAPIA", id_provincia: 19 },
  { id_municipio: 327, descripcion: "MUNICIPIO SAMANÁ", id_provincia: 20 },
  { id_municipio: 328, descripcion: "SAMANÁ", id_provincia: 20 },
  { id_municipio: 329, descripcion: "EL LIMÓN (D. M.)", id_provincia: 20 },
  { id_municipio: 330, descripcion: "ARROYO BARRIL (D. M.)", id_provincia: 20 },
  { id_municipio: 331, descripcion: "LAS GALERAS (D. M.)", id_provincia: 20 },
  { id_municipio: 332, descripcion: "MUNICIPIO SÁNCHEZ", id_provincia: 20 },
  { id_municipio: 333, descripcion: "SÁNCHEZ (D. M.)", id_provincia: 20 },
  { id_municipio: 334, descripcion: "MUNICIPIO LAS TERRENAS", id_provincia: 20 },
  { id_municipio: 335, descripcion: "LAS TERRENAS", id_provincia: 20 },
  { id_municipio: 336, descripcion: "MUNICIPIO SAN CRISTÓBAL", id_provincia: 21 },
  { id_municipio: 337, descripcion: "SAN CRISTÓBAL (D. M.)", id_provincia: 21 },
  { id_municipio: 338, descripcion: "HATO DAMAS (D. M.)", id_provincia: 21 },
  { id_municipio: 339, descripcion: "HATILLO (D. M.)", id_provincia: 21 },
  { id_municipio: 340, descripcion: "MUNICIPIO SABANA GRANDE DE PALENQUE", id_provincia: 21 },
  { id_municipio: 341, descripcion: "SABANA GRANDE DE PALENQUE (D. M.)", id_provincia: 21 },
  { id_municipio: 342, descripcion: "MUNICIPIO BAJOS DE HAINA", id_provincia: 21 },
  { id_municipio: 343, descripcion: "BAJOS DE HAINA", id_provincia: 21 },
  { id_municipio: 344, descripcion: "EL CARRIL (D. M.)", id_provincia: 21 },
  { id_municipio: 345, descripcion: "QUITA SUEÑO (D. M.)", id_provincia: 21 },
  { id_municipio: 346, descripcion: "MUNICIPIO CAMBITA GARABITOS", id_provincia: 21 },
  { id_municipio: 347, descripcion: "CAMBITA GARABITOS", id_provincia: 21 },
  { id_municipio: 348, descripcion: "CAMBITA EL PUEBLECITO (D. M.)", id_provincia: 21 },
  { id_municipio: 349, descripcion: "MUNICIPIO VILLA ALTAGRACIA", id_provincia: 21 },
  { id_municipio: 350, descripcion: "VILLA ALTAGRACIA", id_provincia: 21 },
  { id_municipio: 351, descripcion: "SAN JOSÉ DEL PUERTO (D. M.)", id_provincia: 21 },
  { id_municipio: 352, descripcion: "MEDINA (D. M.)", id_provincia: 21 },
  { id_municipio: 353, descripcion: "LA CUCHILLA (D. M.)", id_provincia: 21 },
  { id_municipio: 354, descripcion: "MUNICIPIO YAGUATE", id_provincia: 21 },
  { id_municipio: 355, descripcion: "YAGUATE (D. M.)", id_provincia: 21 },
  { id_municipio: 356, descripcion: "DOÑA ANA (D. M.)", id_provincia: 21 },
  { id_municipio: 357, descripcion: "MUNICIPIO SAN GREGORIO DE NIGUA", id_provincia: 21 },
  { id_municipio: 358, descripcion: "SAN GREGORIO DE NIGUA", id_provincia: 21 },
  { id_municipio: 359, descripcion: "MUNICIPIO LOS CACAOS", id_provincia: 21 },
  { id_municipio: 360, descripcion: "LOS CACAOS (D. M.)", id_provincia: 21 },
  { id_municipio: 361, descripcion: "MUNICIPIO SAN JUAN", id_provincia: 22 },
  { id_municipio: 362, descripcion: "SAN JUAN", id_provincia: 22 },
  { id_municipio: 363, descripcion: "PEDRO CORTO (D. M.)", id_provincia: 22 },
  { id_municipio: 364, descripcion: "SABANETA (D. M.)", id_provincia: 22 },
  { id_municipio: 365, descripcion: "SABANA ALTA (D. M.)", id_provincia: 22 },
  { id_municipio: 366, descripcion: "EL ROSARIO (D. M.)", id_provincia: 22 },
  { id_municipio: 367, descripcion: "HATO DEL PADRE (D. M.)", id_provincia: 22 },
  { id_municipio: 368, descripcion: "GUANITO (D. M.)", id_provincia: 22 },
  { id_municipio: 369, descripcion: "LA JAGUA (D. M.)", id_provincia: 22 },
  { id_municipio: 370, descripcion: "LAS MAGUANAS-HATO NUEVO (D. M.)", id_provincia: 22 },
  { id_municipio: 371, descripcion: "LAS CHARCAS DE MARÍA NOVA (D. M.)", id_provincia: 22 },
  { id_municipio: 372, descripcion: "LAS ZANJAS (D. M.)", id_provincia: 22 },
  { id_municipio: 373, descripcion: "MUNICIPIO BOHECHÍO", id_provincia: 22 },
  { id_municipio: 374, descripcion: "BOHECHÍO", id_provincia: 22 },
  { id_municipio: 375, descripcion: "ARROYO CANO (D. M.)", id_provincia: 22 },
  { id_municipio: 376, descripcion: "YAQUE (D. M.)", id_provincia: 22 },
  { id_municipio: 377, descripcion: "MUNICIPIO EL CERCADO", id_provincia: 22 },
  { id_municipio: 378, descripcion: "EL CERCADO", id_provincia: 22 },
  { id_municipio: 379, descripcion: "DERRUMBADERO (D. M.)", id_provincia: 22 },
  { id_municipio: 380, descripcion: "BATISTA (D. M.)", id_provincia: 22 },
  { id_municipio: 381, descripcion: "MUNICIPIO JUAN DE HERRERA", id_provincia: 22 },
  { id_municipio: 382, descripcion: "JUAN DE HERRERA", id_provincia: 22 },
  { id_municipio: 383, descripcion: "JÍNOVA (D. M.)", id_provincia: 22 },
  { id_municipio: 384, descripcion: "MUNICIPIO LAS MATAS DE FARFÁN", id_provincia: 22 },
  { id_municipio: 385, descripcion: "LAS MATAS DE FARFÁN", id_provincia: 22 },
  { id_municipio: 386, descripcion: "MATAYAYA (D. M.)", id_provincia: 22 },
  { id_municipio: 387, descripcion: "CARRERA DE YEGUAS (D. M.)", id_provincia: 22 },
  { id_municipio: 388, descripcion: "MUNICIPIO VALLEJUELO", id_provincia: 22 },
  { id_municipio: 389, descripcion: "VALLEJUELO", id_provincia: 22 },
  { id_municipio: 390, descripcion: "JORJILLO (D. M.)", id_provincia: 22 },
  { id_municipio: 391, descripcion: "MUNICIPIO COTUÍ", id_provincia: 24 },
  { id_municipio: 392, descripcion: "COTUÍ", id_provincia: 24 },
  { id_municipio: 393, descripcion: "QUITA SUEÑO (D. M.)", id_provincia: 24 },
  { id_municipio: 394, descripcion: "CABALLERO (D. M.)", id_provincia: 24 },
  { id_municipio: 395, descripcion: "COMEDERO ARRIBA (D. M.)", id_provincia: 24 },
  { id_municipio: 396, descripcion: "PLATANAL (D. M.)", id_provincia: 24 },
  { id_municipio: 397, descripcion: "ZAMBRANA ABAJO", id_provincia: 24 },
  { id_municipio: 398, descripcion: "MUNICIPIO CEVICOS", id_provincia: 24 },
  { id_municipio: 399, descripcion: "CEVICOS", id_provincia: 24 },
  { id_municipio: 400, descripcion: "LA CUEVA (D. M.)", id_provincia: 24 },
  { id_municipio: 401, descripcion: "MUNICIPIO FANTINO", id_provincia: 24 },
  { id_municipio: 402, descripcion: "FANTINO", id_provincia: 24 },
  { id_municipio: 403, descripcion: "MUNICIPIO LA MATA", id_provincia: 24 },
  { id_municipio: 404, descripcion: "LA MATA", id_provincia: 24 },
  { id_municipio: 405, descripcion: "LA BIJA (D. M.)", id_provincia: 24 },
  { id_municipio: 406, descripcion: "ANGELINA (D. M.)", id_provincia: 24 },
  { id_municipio: 407, descripcion: "HERNANDO ALONZO (D. M.)", id_provincia: 24 },
  { id_municipio: 408, descripcion: "MUNICIPIO SANTIAGO", id_provincia: 25 },
  { id_municipio: 409, descripcion: "SANTIAGO", id_provincia: 25 },
  { id_municipio: 410, descripcion: "PEDRO GARCÍA (D. M.)", id_provincia: 25 },
  { id_municipio: 411, descripcion: "BAITOA (D. M.)", id_provincia: 25 },
  { id_municipio: 412, descripcion: "LA CANELA (D. M.)", id_provincia: 25 },
  { id_municipio: 413, descripcion: "SAN FRANCISCO DE JACAGUA (D. M.)", id_provincia: 25 },
  { id_municipio: 414, descripcion: "HATO DEL YAQUE (D. M.)", id_provincia: 25 },
  { id_municipio: 415, descripcion: "MUNICIPIO BISONÓ", id_provincia: 25 },
  { id_municipio: 416, descripcion: "VILLA BISONÓ (NAVARRETE) (D. M.)", id_provincia: 25 },
  { id_municipio: 417, descripcion: "MUNICIPIO JÁNICO", id_provincia: 25 },
  { id_municipio: 418, descripcion: "JÁNICO", id_provincia: 25 },
  { id_municipio: 419, descripcion: "JUNCALITO (D. M.)", id_provincia: 25 },
  { id_municipio: 420, descripcion: "EL CAIMITO (D. M.)", id_provincia: 25 },
  { id_municipio: 421, descripcion: "MUNICIPIO LICEY AL MEDIO", id_provincia: 25 },
  { id_municipio: 422, descripcion: "LICEY AL MEDIO", id_provincia: 25 },
  { id_municipio: 423, descripcion: "LAS PALOMAS (D. M.)", id_provincia: 25 },
  { id_municipio: 424, descripcion: "MUNICIPIO SAN JOSÉ DE LAS MATAS", id_provincia: 25 },
  { id_municipio: 425, descripcion: "SAN JOSÉ DE LAS MATAS", id_provincia: 25 },
  { id_municipio: 426, descripcion: "EL RUBIO (D. M.)", id_provincia: 25 },
  { id_municipio: 427, descripcion: "LA CUESTA (D. M.)", id_provincia: 25 },
  { id_municipio: 428, descripcion: "LAS PLACETAS (D. M.)", id_provincia: 25 },
  { id_municipio: 429, descripcion: "MUNICIPIO TAMBORIL", id_provincia: 25 },
  { id_municipio: 430, descripcion: "TAMBORIL", id_provincia: 25 },
  { id_municipio: 431, descripcion: "CANCA LA PIEDRA (D. M.)", id_provincia: 25 },
  { id_municipio: 432, descripcion: "MUNICIPIO VILLA GONZÁLEZ", id_provincia: 25 },
  { id_municipio: 433, descripcion: "VILLA GONZÁLEZ", id_provincia: 25 },
  { id_municipio: 434, descripcion: "PALMAR ARRIBA (D. M.)", id_provincia: 25 },
  { id_municipio: 435, descripcion: "EL LIMÓN (D. M.)", id_provincia: 25 },
  { id_municipio: 436, descripcion: "MUNICIPIO PUÑAL", id_provincia: 25 },
  { id_municipio: 437, descripcion: "PUÑAL", id_provincia: 25 },
  { id_municipio: 438, descripcion: "GUAYABAL (D. M.)", id_provincia: 25 },
  { id_municipio: 439, descripcion: "CANABACOA (D. M.)", id_provincia: 25 },
  { id_municipio: 440, descripcion: "MUNICIPIO SABANA IGLESIA", id_provincia: 25 },
  { id_municipio: 441, descripcion: "SABANA IGLESIA", id_provincia: 25 },
  { id_municipio: 442, descripcion: "BAITOA", id_provincia: 25 },
  { id_municipio: 443, descripcion: "BAITOA", id_provincia: 25 },
  { id_municipio: 444, descripcion: "MUNICIPIO SAN IGNACIO DE SABANETA", id_provincia: 26 },
  { id_municipio: 445, descripcion: "SAN IGNACIO DE SABANETA (D. M.)", id_provincia: 26 },
  { id_municipio: 446, descripcion: "MUNICIPIO VILLA LOS ALMÁCIGOS", id_provincia: 26 },
  { id_municipio: 447, descripcion: "VILLA LOS ALMÁCIGOS (D. M.)", id_provincia: 26 },
  { id_municipio: 448, descripcion: "MUNICIPIO MONCIÓN", id_provincia: 26 },
  { id_municipio: 449, descripcion: "MONCIÓN (D. M.)", id_provincia: 26 },
  { id_municipio: 450, descripcion: "MUNICIPIO MAO", id_provincia: 27 },
  { id_municipio: 451, descripcion: "MAO (D. M.)", id_provincia: 27 },
  { id_municipio: 452, descripcion: "AMINA (D. M.)", id_provincia: 27 },
  { id_municipio: 453, descripcion: "JAIBÓN (PUEBLO NUEVO) (D. M.)", id_provincia: 27 },
  { id_municipio: 454, descripcion: "GUATAPANAL (D. M.)", id_provincia: 27 },
  { id_municipio: 455, descripcion: "MUNICIPIO ESPERANZA", id_provincia: 27 },
  { id_municipio: 456, descripcion: "ESPERANZA", id_provincia: 27 },
  { id_municipio: 457, descripcion: "MAIZAL (D. M.)", id_provincia: 27 },
  { id_municipio: 458, descripcion: "JICOMÉ (D. M.)", id_provincia: 27 },
  { id_municipio: 459, descripcion: "BOCA DE MAO (D. M.)", id_provincia: 27 },
  { id_municipio: 460, descripcion: "PARADERO (D. M.)", id_provincia: 27 },
  { id_municipio: 461, descripcion: "MUNICIPIO LAGUNA SALADA", id_provincia: 27 },
  { id_municipio: 462, descripcion: "LAGUNA SALADA (D. M.)", id_provincia: 27 },
  { id_municipio: 463, descripcion: "JAIBÓN (D. M.)", id_provincia: 27 },
  { id_municipio: 464, descripcion: "LA CAYA (D. M.)", id_provincia: 27 },
  { id_municipio: 465, descripcion: "CRUCE DE GUAYACANES (D. M.)", id_provincia: 27 },
  { id_municipio: 466, descripcion: "MUNICIPIO BONAO", id_provincia: 28 },
  { id_municipio: 467, descripcion: "BONAO (D. M.)", id_provincia: 28 },
  { id_municipio: 468, descripcion: "SABANA DEL PUERTO (D. M.)", id_provincia: 28 },
  { id_municipio: 469, descripcion: "JUMA BEJUCAL (D. M.)", id_provincia: 28 },
  { id_municipio: 470, descripcion: "ARROYO TORO - MASIPEDRO (D. M.)", id_provincia: 28 },
  { id_municipio: 471, descripcion: "JAYACO (D. M.)", id_provincia: 28 },
  { id_municipio: 472, descripcion: "LA SALVIA - LOS QUEMADOS (D. M.)", id_provincia: 28 },
  { id_municipio: 473, descripcion: "MUNICIPIO MAIMÓN", id_provincia: 28 },
  { id_municipio: 474, descripcion: "MAIMÓN (D. M.)", id_provincia: 28 },
  { id_municipio: 475, descripcion: "MUNICIPIO PIEDRA BLANCA", id_provincia: 28 },
  { id_municipio: 476, descripcion: "PIEDRA BLANCA (D. M.)", id_provincia: 28 },
  { id_municipio: 477, descripcion: "VILLA DE SONADOR (D. M.)", id_provincia: 28 },
  { id_municipio: 478, descripcion: "JUAN ADRIÁN (D. M.)", id_provincia: 28 },
  { id_municipio: 479, descripcion: "MUNICIPIO MONTE PLATA", id_provincia: 29 },
  { id_municipio: 480, descripcion: "MONTE PLATA (D. M.)", id_provincia: 29 },
  { id_municipio: 481, descripcion: "DON JUAN (D. M.)", id_provincia: 29 },
  { id_municipio: 482, descripcion: "CHIRINO (D. M.)", id_provincia: 29 },
  { id_municipio: 483, descripcion: "BOYÁ (D. M.)", id_provincia: 29 },
  { id_municipio: 484, descripcion: "MUNICIPIO BAYAGUANA", id_provincia: 29 },
  { id_municipio: 485, descripcion: "BAYAGUANA (D. M.)", id_provincia: 29 },
  { id_municipio: 486, descripcion: "MUNICIPIO SABANA GRANDE DE BOYÁ", id_provincia: 29 },
  { id_municipio: 487, descripcion: "SABANA GRANDE DE BOYÁ (D. M.)", id_provincia: 29 },
  { id_municipio: 488, descripcion: "GONZALO (D. M.)", id_provincia: 29 },
  { id_municipio: 489, descripcion: "MAJAGUAL (D. M.)", id_provincia: 29 },
  { id_municipio: 490, descripcion: "MUNICIPIO YAMASÁ", id_provincia: 29 },
  { id_municipio: 491, descripcion: "LOS BOTADOS (D. M.)", id_provincia: 29 },
  { id_municipio: 492, descripcion: "MAMÁ TINGÓ (D. M.)", id_provincia: 29 },
  { id_municipio: 493, descripcion: "MUNICIPIO PERALVILLO", id_provincia: 29 },
  { id_municipio: 494, descripcion: "PERALVILLO (D. M.)", id_provincia: 29 },
  { id_municipio: 495, descripcion: "MUNICIPIO HATO MAYOR", id_provincia: 30 },
  { id_municipio: 496, descripcion: "HATO MAYOR (D. M.)", id_provincia: 30 },
  { id_municipio: 497, descripcion: "YERBA BUENA (D. M.)", id_provincia: 30 },
  { id_municipio: 498, descripcion: "MATA PALACIO (D. M.)", id_provincia: 30 },
  { id_municipio: 499, descripcion: "GUAYABO DULCE (D. M.)", id_provincia: 30 },
  { id_municipio: 500, descripcion: "MUNICIPIO SABANA DE LA MAR", id_provincia: 30 },
  { id_municipio: 501, descripcion: "SABANA DE LA MAR (D. M.)", id_provincia: 30 },
  { id_municipio: 502, descripcion: "ELUPINA CORDERO DE LAS CAÑITAS (D. M.)", id_provincia: 30 },
  { id_municipio: 503, descripcion: "MUNICIPIO EL VALLE", id_provincia: 30 },
  { id_municipio: 504, descripcion: "EL VALLE (D. M.)", id_provincia: 30 },
  { id_municipio: 505, descripcion: "MUNICIPIO SAN JOSÉ DE OCOA", id_provincia: 31 },
  { id_municipio: 506, descripcion: "SAN JOSÉ DE OCOA (D. M.)", id_provincia: 31 },
  { id_municipio: 507, descripcion: "LA CIÉNAGA (D. M.)", id_provincia: 31 },
  { id_municipio: 508, descripcion: "NIZAO - LAS AUYAMAS (D. M.)", id_provincia: 31 },
  { id_municipio: 509, descripcion: "EL PINAR (D. M.)", id_provincia: 31 },
  { id_municipio: 510, descripcion: "EL NARANJAL (D. M.)", id_provincia: 31 },
  { id_municipio: 511, descripcion: "MUNICIPIO SABANA LARGA", id_provincia: 31 },
  { id_municipio: 512, descripcion: "SABANA LARGA (D. M.)", id_provincia: 31 },
  { id_municipio: 513, descripcion: "MUNICIPIO RANCHO ARRIBA", id_provincia: 31 },
  { id_municipio: 514, descripcion: "RANCHO ARRIBA (D. M.)", id_provincia: 31 },
  { id_municipio: 515, descripcion: "MUNICIPIO SANTO DOMINGO ESTE", id_provincia: 32 },
  { id_municipio: 516, descripcion: "SANTO DOMINGO ESTE (D. M.)", id_provincia: 32 },
  { id_municipio: 517, descripcion: "SAN LUIS (D. M.)", id_provincia: 32 },
  { id_municipio: 518, descripcion: "MUNICIPIO SANTO DOMINGO OESTE", id_provincia: 32 },
  { id_municipio: 519, descripcion: "SANTO DOMINGO OESTE (D. M.)", id_provincia: 32 },
  { id_municipio: 520, descripcion: "MUNICIPIO SANTO DOMINGO NORTE", id_provincia: 32 },
  { id_municipio: 521, descripcion: "SANTO DOMINGO NORTE (D. M.)", id_provincia: 32 },
  { id_municipio: 522, descripcion: "LA VICTORIA (D. M.)", id_provincia: 32 },
  { id_municipio: 523, descripcion: "MUNICIPIO BOCA CHICA", id_provincia: 32 },
  { id_municipio: 524, descripcion: "BOCA CHICA (D. M.)", id_provincia: 32 },
  { id_municipio: 525, descripcion: "LA CALETA (D. M.)", id_provincia: 32 },
  { id_municipio: 526, descripcion: "MUNICIPIO SAN ANTONIO DE GUERRA", id_provincia: 32 },
  { id_municipio: 527, descripcion: "SAN ANTONIO DE GUERRA (D. M.)", id_provincia: 32 },
  { id_municipio: 528, descripcion: "HATO VIEJO (D. M.)", id_provincia: 32 },
  { id_municipio: 529, descripcion: "MUNICIPIO LOS ALCARRIZOS", id_provincia: 32 },
  { id_municipio: 530, descripcion: "LOS ALCARRIZOS (D. M.)", id_provincia: 32 },
  { id_municipio: 531, descripcion: "PALMAREJO-VILLA LINDA (D. M.)", id_provincia: 32 },
  { id_municipio: 532, descripcion: "PANTOJA (D. M.)", id_provincia: 32 },
  { id_municipio: 533, descripcion: "MUNICIPIO PEDRO BRAND", id_provincia: 32 },
  { id_municipio: 534, descripcion: "PEDRO BRAND (D. M.)", id_provincia: 32 },
  { id_municipio: 535, descripcion: "LA GUÁYIGA (D. M.)", id_provincia: 32 },
  { id_municipio: 536, descripcion: "LA CUABA (D. M.)", id_provincia: 32 },
];

export const obtenerProvinciasPorPais = (id_pais) =>
  PROVINCIAS.filter((p) => p.id_pais === parseInt(id_pais));

export const obtenerMunicipiosPorProvincia = (id_provincia) =>
  MUNICIPIOS.filter((m) => m.id_provincia === parseInt(id_provincia));
